/**
 * Where a member of a tenant goes when the tenant declares itself a master account.
 * - MASTER_ACCOUNT_MEMBER: joins the new master account as MASTER_ACCOUNTANT; reaches the own books by assignment
 * - EMPLOYEE: stays a direct member of the own books ("Moje kancelář")
 */
export const MasterAccountMemberClassification = {
  MASTER_ACCOUNT_MEMBER: 'MASTER_ACCOUNT_MEMBER',
  EMPLOYEE: 'EMPLOYEE'
} as const;

export type MasterAccountMemberClassification =
  (typeof MasterAccountMemberClassification)[keyof typeof MasterAccountMemberClassification];
